import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const Shifts = lazy(() => import('@pages/Shifts').then((m) => ({ default: m.Shifts })));

// Route Component
const ShiftsPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('shifts-page-title')}>
        <Shifts />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ShiftsPage,
};
